import { WidgetType } from 'widgets/WidgetType';
import { ChannelDestination } from 'communication/Channel';

export default function widgetStreamKey(
    widgetType: WidgetType,
    widgetKey: string,
    channel: ChannelDestination
) {
    return `widget-${widgetType}|${widgetKey}-${channel}`;
}
